import React, { useMemo, useState } from 'react'
import { Card, Row, Col, Button, Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import config from '../../config'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import axios from 'axios'
import { alertBeforeHandle } from './utils'
import { useSelector } from 'react-redux'

const ManageNoFee = ({ setIsVisible, onClose }) => {
  const dispatch = useDispatch()
  const { allowedNoFeeList } = useSelector((state) => state.webConfig)

  const [inputUserIdList, setInputUserIdList] = useState(allowedNoFeeList.length > 0 ? allowedNoFeeList : [''])

  const isDisabledButton = useMemo(() => {
    return inputUserIdList.length === 0 || inputUserIdList.some((item) => item === '')
  }, [inputUserIdList])

  const handleClickAddUserId = () => {
    setInputUserIdList((prev) => [...prev, ''])
  }

  const handleClickRemoveUserId = (inputIndex) => {
    setInputUserIdList(inputUserIdList.filter((_, index) => index !== inputIndex))
  }

  const handleClickSaveUserIdList = async () => {
    alertBeforeHandle('ต้องการบันทึกการตั้งค่า', async () => {
      try {
        dispatch({ type: 'loading_show' })
        await axios.patch(
          `${config.apiAdminGateway}/api/v1/admin/configs/strlist/allowedNoFeeList`,
          { value: inputUserIdList.filter((item) => item !== '') },
          {
            headers: {
              authorization: `Bearer ${Cookies.get('accessToken')}`
            }
          },
        )

        Swal.fire({
          title: 'บันทึกการตั้งค่าสำเร็จ!',
          icon: 'success',
          confirmButtonColor: Colors.SOFT_BLUE,
        }).then(() => {
          setIsVisible(false)
          onClose()
        })
      } catch (error) {
        console.error('Error while trying to save data.', error)
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    })
  }

  return (
    <Card>
      <Row>
        <Col md={12}>
          <Button variant="primary" className="m-1" onClick={handleClickAddUserId}>เพิ่มรหัสผู้ใช้</Button>
          {inputUserIdList.map((item, index) => {
            return (
              <Row key={index} className="my-1">
                <Col md={8}>
                  <Form.Control
                    aria-label="Small"
                    aria-describedby="inputGroup-sizing-sm"
                    value={item}
                    onChange={(e) => {
                      const newInputUserIdList = [...inputUserIdList]
                      newInputUserIdList[index] = e.target.value.toLocaleUpperCase()
                      setInputUserIdList(newInputUserIdList)
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Button variant="warning" onClick={() => handleClickRemoveUserId(index)}>ลบรหัสผู้ใช้</Button>
                </Col>
              </Row>
            )
          })}
          <Button
            className="mt-4 btn btn-success light"
            style={{ width: '100%' }}
            key="submit"
            type="primary"
            onClick={handleClickSaveUserIdList}
            disabled={isDisabledButton}
          >
            บันทึกข้อมูล
          </Button>
        </Col>
      </Row>
    </Card>
  )
}

export default ManageNoFee
